<template>
  <el-tooltip
    class="item"
    effect="dark"
    placement="top-end"
    :open-delay="openDelay"
    :content="tip"
    >
    <el-button
      v-bind="$attrs"
      size="small"
      :type="type"
      :icon="icon"
      @click="handleClick"
      >
      <svg-icon
        v-if="!icon && iconClass !== ''"
        :icon-class="iconClass"
        >
      </svg-icon>
    </el-button>
  </el-tooltip>
</template>

<script>

export default {
  name: 'act-btn',
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    tip: {
      type: String
    },
    icon: {
      type: String
    },
    iconClass: {
      type: String
    },
    openDelay: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  }
}
</script>
